<template>
    <div
        class="app"
        :style="
      bForshow || bPreview ? 'padding-bottom: 70px;' : 'padding-bottom: 0px;'
    "
    >
        <h3 class="tt">A.O.史密斯<br/>用户安装实例</h3>
        <div class="user-info">
            <div class="headimg">
                <img src="https://pro-core.babycdn.com/2020/08aosmith/images2020/release_case/headimg.jpg">
            </div>
            <div class="info">
                <h3>案例信息</h3>
                <div class="txt"><span>城市：{{ oDetails.city_name }}</span><span>小区：{{ oDetails.address }}</span></div>
                <div class="txt">面积：{{ oDetails.house_area }}m²</div>
            </div>
        </div>
        <div class="case-list">
            <!-- <h3>安装案例</h3> -->
            <div class="case-item" v-if="oDetails.genre_img">
                <h5>口碑晒单</h5>
                <div class="image-wrap">
                    <img
                        v-lazy="oDetails.genre_image[0].img_url"
                        alt="图片"/>
                </div>
            </div>

            <div class="case-item" v-for="(item,index) in oDetails.new_scenes" :key="item.id">
                <h5>{{ item.scenes_name ? item.scenes_name + "场景" : "" }}</h5>
                <!--         <vuedraggable v-model="item.house_img" @end="draggableEnd(index)">
                            <transition-group> -->
                <div
                    class="image-wrap"
                    v-for="(imgitem, imgindex) in item.house_img"
                >
                    <img
                        v-lazy="imgitem.img_url"
                        alt="图片"
                        @click="swiperChange(item.arrImg, imgindex)"
                    />
                    <img src="@/assets/images/case/icon_del.png" class="icon-del" @click="del(index,imgindex)">
                    <div class="move">
                        <div class="item" @click="moveUp(index,imgindex)" v-if="imgindex != 0 && imgindex != 0">
                            <img src="@/assets/images/case/icon_up.png">
                        </div>
                        <div class="item item-down" @click="moveDown(index,imgindex)" v-if="item.house_img.length != 0 && imgindex != item.house_img.length-1">
                            <img src="@/assets/images/case/icon_up.png">
                        </div>
                    </div>
                </div><!--
          </transition-group>
        </vuedraggable> -->
                <div class="viebeo" v-if="item.mp4">
                    <img src="@/assets/images/case/icon_del.png" class="icon-del" @click="delvideo(index,item)">
                    <video :src="item.mp4 ? item.mp4 : ''" :poster="item.mp4_rectangle_cover_url" controls webkit-displaying-fullscreen="false"
                           x-webkit-airplay="true"
                           x5-playsinline="true"
                           webkit-playsinline="true"
                           playsinline="true"></video>
                </div>
                <div class="goods-wrap" v-if="item.goods_info.length">
                    <div class="titel">
                        <span class="left"></span>
                        案例中的商品
                        <span class="right"></span>
                    </div>
                    <ul class="goods-list">
                        <li
                            v-for="git in item.goods_info"
                            :key="git.id"
                            v-if="git.id"
                            @click="godetails(git.id)"
                        >
                            <div class="img-box">
                                <img :src="git.mobile_thumb"/>
                            </div>
                            <div class="title">
                                <div>{{ git.goods_type_name }}</div>
                                <div>{{ git.goods_name }}</div>
                                <div
                                    class="selling"
                                    v-for="(gitem, gindex) in git.attr"
                                    :key="gindex"
                                    v-if="gitem.attr_mean < 4 && gindex < 3"
                                >
                  <span style="margin-right: 10px">{{
                          gitem.attr_value ? "·" : ""
                      }}</span
                  >{{ gitem.attr_value ? gitem.attr_value : "" }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="foot-img">
                <div class="logo">
                    <img src="@/assets/images/system/logo2.png"/>
                </div>
            </div>
        </div>
        <div class="examine" v-if="bForshow">
            <div @click="isNoThrWin = true">不通过</div>
            <div @click="ThroughWin = true">通过</div>
        </div>
        <div class="preview" v-if="bPreview">
            <div class="preservation" @click="submit">提交</div>
            <div class="draft" @click="getdraftcase">保存草稿案例</div>
        </div>
        <!-- 审核不通过弹窗 -->
        <div class="no-through-win" v-if="isNoThrWin">
            <div class="win-con">
        <textarea
            name
            class="textarea-el"
            v-model="noThroughText"
            id
            cols="30"
            maxlength="-1"
            rows="10"
            placeholder="请输入案例审核不通过原因！"
        ></textarea>
                <div class="textarea-event-box">
                    <div class="event-disabled" @click="isNoThrWin = false">取消</div>
                    <div @click="setNoThroughText">确定</div>
                </div>
            </div>
        </div>
        <!-- 审核通过弹窗 -->
        <div class="del-win" v-if="ThroughWin">
            <div class="del-tip">
                <img class="cover-img" src alt/>
                <div class="tip-text">您确定通过该案例的审核吗？</div>
                <div class="close-win" @click="ThroughWin = false">取消</div>
                <div class="query-delete" @click="querySetTop">确认</div>
            </div>
        </div>
        <!-- 预览图片 -->
        <div class="preview-img" v-show="showSwiper">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="item in arrSwiperImg" :key="item.id">
                    <div class="swiper-zoom-container">
                        <img :src="item" alt/>
                    </div>
                </swiper-slide>
                <!--<div class="swiper-pagination "  slot="pagination"></div>-->
            </swiper>
        </div>
        <div v-show="showSwiper" class="close-preview" @click="closeSwiper">
            关闭预览
        </div>
        <!-- 预览头图 -->
        <div class="preview-img" v-show="headerSwiper">
            <swiper :options="swiperOptiontwo" ref="mySwipertwo">
                <swiper-slide v-for="item in arrHeaderImg" :key="item.id">
                    <div class="swiper-zoom-container">
                        <img :src="item" alt/>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <div v-show="headerSwiper" class="close-preview" @click="getheaderSwiper">
            关闭预览
        </div>
    </div>
</template>
<script>
import path from "@/path.js";
import {MessageBox} from "mint-ui";
import vuedraggable from 'vuedraggable';

export default {
    components: {
        vuedraggable
    },
    data() {
        return {
            oDetails: "", //案例详情
            bShow: false,
            bForshow: false, //显示通过不通过按钮
            isNoThrWin: false, //审核不通过弹窗
            ThroughWin: false, //审核通过弹窗
            noThroughText: "", //不通过理由
            bPreview: false, //来源案例预览
            arrScenes: [], //scense_JSON类型
            arrPlot: {}, //plot_JSON类型
            arrPloteaid: {}, //编辑草稿
            showSwiper: false, //预览图片
            headerSwiper: false, //预览头图
            arrHeaderImg: [], //头图
            arrSwiperImg: [], //需要预览的图片
            swiperIndex: 2,
            swiperIndextwo: 0,
            swiperOption: {
                clickable: true,
                noSwiping: true,
                zoom: true,
                on: {
                    slideChangeTransitionStart: function (swiper) {
                        this.swiperIndex = this.swiper.activeIndex;
                    }.bind(this),
                },
            },
            swiperOptiontwo: {
                clickable: true,
                noSwiping: true,
                zoom: true,
                on: {
                    slideChangeTransitionStart: function (swipertwo) {
                        this.swiperIndextwo = this.swipertwo.activeIndex;
                    }.bind(this),
                },
            },
        };
    },
    created() {
        this.getform();
        this.getDetails();
        this.$store.commit("loadSwitch", true);
    },
    computed: {
        swiper() {
            this.swiperIndex = this.$refs.mySwiper.swiper.activeIndex;
            return this.$refs.mySwiper.swiper;
        },
        swipertwo() {
            this.swiperIndextwo = this.$refs.mySwipertwo.swiperIndextwo.activeIndex;
            return this.$refs.mySwipertwo.swiperIndextwo;
        },
    },
    methods: {
        delvideo(index, item) {
            MessageBox.confirm('是否确认删除?').then(action => {
                this.$store.commit("loadSwitch", true);
                path.post5(path.topicModeVideo, {
                    scence_id: this.oDetails.new_scenes[index].scenes_id,
                    draft_id: this.$route.query.draftid,
                    mp4_id: item.id,
                    user_id: this.$route.query.userid
                }).then((res) => {
                    this.$store.commit("loadSwitch", false);
                    if (res.data.error == 0) {
                        item = {};
                    } else {
                        this.$toast({
                            message: res.data.msg,
                            duration: 500,
                        });
                    }
                });
            });
        },
        del(index, imgindex) {
            MessageBox.confirm('是否确认删除?').then(action => {
                this.$store.commit("loadSwitch", true);
                let arr = this.oDetails.new_scenes[index].house_img.map(item => {
                    return item.img_id
                })
                arr.splice(imgindex, 1);
                path.post5(path.topicModeScence, {
                    scence_id: this.oDetails.new_scenes[index].scenes_id,
                    draft_id: this.$route.query.draftid,
                    img_id: arr.join(','),
                    user_id: this.$route.query.userid
                }).then((res) => {
                    this.$store.commit("loadSwitch", false);
                    if (res.data.error == 0) {
                        this.oDetails.new_scenes[index].house_img.splice(imgindex, 1);
                    } else {
                        this.$toast({
                            message: res.data.msg,
                            duration: 500,
                        });
                    }
                });
            });
        },
        moveUp(index, imgindex) {
            this.$store.commit("loadSwitch", true);
            let arr = this.oDetails.new_scenes[index].house_img.map(item => {
                return item.img_id
            })
            if (imgindex != 0) {
                arr[imgindex] = arr.splice(imgindex - 1, 1, arr[imgindex])[0];
            } else {
                arr.push(arr.shift());
            }
            path.post5(path.topicModeScence, {
                scence_id: this.oDetails.new_scenes[index].scenes_id,
                draft_id: this.$route.query.draftid,
                img_id: arr.join(','),
                user_id: this.$route.query.userid
            }).then((res) => {
                this.$store.commit("loadSwitch", false);
                if (res.data.error == 0) {
                    var house_img = this.oDetails.new_scenes[index].house_img;
                    if (imgindex != 0) {
                        house_img[imgindex] = house_img.splice(imgindex - 1, 1, house_img[imgindex])[0];
                    } else {
                        house_img.push(house_img.shift());
                    }
                    this.$forceUpdate();
                    // house_img.splice(imgindex-1,1,...house_img.splice(imgindex,1,house_img[0]));
                    // house_img.splice(imgindex-1,1,...house_img.splice(imgindex,1,house_img[0]));
                } else {
                    this.$toast({
                        message: res.data.msg,
                        duration: 500,
                    });
                }
            });
        },
        moveDown(index, imgindex) {
            this.$store.commit("loadSwitch", true);
            let arr = this.oDetails.new_scenes[index].house_img.map(item => {
                return item.img_id
            })
            if (imgindex != arr.length - 1) {
                arr[imgindex] = arr.splice(imgindex + 1, 1, arr[imgindex])[0];
            } else {
                arr.unshift(arr.splice(imgindex, 1)[0]);
            }
            path.post5(path.topicModeScence, {
                scence_id: this.oDetails.new_scenes[index].scenes_id,
                draft_id: this.$route.query.draftid,
                img_id: arr.join(','),
                user_id: this.$route.query.userid
            }).then((res) => {
                this.$store.commit("loadSwitch", false);
                if (res.data.error == 0) {
                    var house_img = this.oDetails.new_scenes[index].house_img;
                    if (imgindex != house_img.length - 1) {
                        house_img[imgindex] = house_img.splice(imgindex + 1, 1, house_img[imgindex])[0];
                    } else {
                        house_img.unshift(house_img.splice(imgindex, 1)[0]);
                    }
                    this.$forceUpdate();
                } else {
                    this.$toast({
                        message: res.data.msg,
                        duration: 500,
                    });
                }
            });
        },
        draggableEnd(itemIndex) {
            this.$store.commit("loadSwitch", true);
            let arr = this.oDetails.new_scenes[itemIndex].house_img.map(item => {
                return item.img_id
            })
            path.post5(path.topicModeScence, {
                scence_id: this.oDetails.new_scenes[itemIndex].scenes_id,
                topic_id: this.$route.query.draftid,
                img_id: arr.join(','),
                user_id: this.$route.query.userid
            }).then((res) => {
                //  console.log("记录拖拽位置", res);
                this.$store.commit("loadSwitch", false);
                if (res.data.error == 0) {

                } else {
                    this.$toast({
                        message: res.data.msg,
                        duration: 500,
                    });
                }
            });
        },
        //点击打开预览
        swiperChange(arr, index) {
            var that = this;
            //  console.log(index);
            if (index >= 0) {
                that.showSwiper = true;
                this.arrSwiperImg = [];
                this.arrSwiperImg = arr;
                that.swiper.slideTo(index, 1000, true);
            }
        },
        //点击关闭预览
        closeSwiper() {
            var that = this;
            that.showSwiper = false;
        },
        //点击打开预览头图
        headerChange(index) {
            var that = this;
            //  console.log(index);
            if (index >= 0) {
                that.headerSwiper = true;
                that.swiper.slideTo(index, 1000, true);
            }
        },
        //点击关闭预览头图
        getheaderSwiper() {
            var that = this;
            that.headerSwiper = false;
        },
        //编辑草稿
        getdraftcase() {
            let data = {
                user_id: this.$route.query.userid,
                source: "xcx",
                draft_id: this.$route.query.draftid,
                title: this.oDetails.title,
                search: this.oDetails.search_key,
                province: this.oDetails.province,
                city_id: this.oDetails.city,
                address: this.oDetails.address,
                house_area: this.oDetails.house_area,
                house_style: this.oDetails.house_style,
                act_id: this.oDetails.act_id,
                house_img: this.oDetails.house_type_img,
                odd_code: this.oDetails.odd_code,
                scene_json: JSON.stringify(this.arrScenes),
                cover_url: this.oDetails.cover_url,
                from: 0,
                // plot_json: JSON.stringify(this.arrPloteaid),
                plot_json: JSON.stringify(this.oDetails.plot),
            };
            this.$store.commit("loadSwitch", true);
            path.post(path.editDraft, data).then((res) => {
                this.$store.commit("loadSwitch", false);
                //  console.log(res);
                if (res.data.error == 0) {
                    this.$toast({
                        message: "保存草稿成功",
                        duration: 1000,
                    });
                    setTimeout(() => {
                        wx.miniProgram.reLaunch({
                            url: `/pages/case/my_case_xue/index?index=${1}`,
                        });
                    }, 1200);
                }
            });
        },
        //提交案例审核
        submit() {
            let data = {
                user_id: this.$route.query.userid,
                source: "xcx",
                draft_id: this.$route.query.draftid,
                title: this.oDetails.title,
                search: this.oDetails.search_key,
                province: this.oDetails.province,
                city_id: this.oDetails.city,
                address: this.oDetails.address,
                house_area: this.oDetails.house_area,
                house_style: this.oDetails.house_style,
                act_id: this.oDetails.act_id,
                house_img: this.oDetails.house_type_img,
                odd_code: this.oDetails.odd_code,
                scene_json: JSON.stringify(this.arrScenes),
                cover_url: this.oDetails.cover_url,
                from: 1,
                plot_json: JSON.stringify(this.oDetails.plot),
            };
            this.$store.commit("loadSwitch", true);
            path.post(path.editDraft, data).then((res) => {
                this.$store.commit("loadSwitch", false);
                if (res.data.error == 0) {
                    this.$toast({
                        message: "提交成功",
                        duration: 1000,
                    });
                    setTimeout(() => {
                        wx.miniProgram.navigateTo({
                            url: `/pages/case/my_case_xue/index?index=${0}`,
                        });
                    }, 1200);
                }
                //  console.log(res);
            });
        },
        //判断来源是否为管理案例和案例预览
        getform() {
            let that = this;
            //console.log(this.$route.query.oForm)
            let oForm = this.$route.query.form;
            if (oForm == "mine") {
                that.bForshow = true;
            } else {
                that.bForshow = false;
            }
            if (oForm == "preser") {
                that.bPreview = true;
                //console.log(that.bPreview)
            } else {
                that.bPreview = false;
            }
        },
        //确认通过审核
        querySetTop() {
            let data = {
                topic_id: this.$route.query.draftid,
                source: "xcx",
                is_pass: 1,
                ref_reason: this.noThroughText,
                user_id: this.$route.query.userid,
            };
            this.$store.commit("loadSwitch", true);
            path.post5(path.getcheck, data).then((res) => {
                //  console.log("-->1", res);
                if (res.data.error == 0) {
                    this.$store.commit("loadSwitch", false);
                    this.$toast({
                        message: res.data.data.msg,
                        duration: 1200,
                    });
                    this.ThroughWin = false;
                    setTimeout(() => {
                        wx.miniProgram.navigateBack({
                            delta: 1,
                        });
                    }, 800);
                }
            });
        },
        //确认不通过
        setNoThroughText() {
            if (this.noThroughText == "") {
                this.$toast({
                    message: "请填写不通过原因",
                    duration: 1200,
                });
                return false;
            }
            let data = {
                topic_id: this.$route.query.draftid,
                source: "xcx",
                is_pass: 0,
                ref_reason: this.noThroughText,
                user_id: this.$route.query.userid,
            };
            this.$store.commit("loadSwitch", true);
            path.post5(path.getcheck, data).then((res) => {
                //console.log("-->2", res);
                if (res.data.error == 0) {
                    this.$store.commit("loadSwitch", false);
                    this.$toast({
                        message: res.data.data.msg,
                        duration: 1200,
                    });
                    this.isNoThrWin = false;
                    setTimeout(() => {
                        wx.miniProgram.navigateBack({
                            delta: 1,
                        });
                    }, 800);
                }
            });
        },
        //跳转直接
        //跳转添加活动页面
        // gosarea() {
        //   wx.miniProgram.navigateTo({ url: "/pages/watersystem/activity/index" });
        // },
        //点击跳转详情页
        godetails(id) {
            //  console.log("商品id", id);
            wx.miniProgram.navigateTo({url: `/pages/pro_type_v2/index?id=${id}`});
        },
        //收藏案例
        getcollection() {
            let data = {
                type: "topic",
                user_id: this.$route.query.userid,
                xid: this.oDetails.id,
                title:
                    this.oDetails.province_name +
                    "-" +
                    this.oDetails.city_name +
                    "-" +
                    this.oDetails.address,
                source: "xcx",
            };
            this.$store.commit("loadSwitch", true);
            path.post5(path.getcollect, data).then((res) => {
                //  console.log("收藏案例", res);
                if (res.data.error == 0) {
                    this.$store.commit("loadSwitch", false);
                    this.$toast({
                        message: res.data.data.result.msg,
                        duration: 500,
                    });
                }
            });
        },
        getDetails() {
            let data = {
                draft_id: this.$route.query.draftid,
                source: "xcx",
                user_id: this.$route.query.userid,
            };
            this.$store.commit("loadSwitch", true);
            path.post5(path.getdraft, data).then((res) => {
                if (res.data.error == 0) {
                    this.$store.commit("loadSwitch", false);
                    this.oDetails = res.data.data.result;
                    let arrDetails = res.data.data.result;
                    let arrSwiperImg = [];
                    let arrHeaderImg = [];
                    arrHeaderImg.push(arrDetails.cover);
                    this.arrHeaderImg = arrHeaderImg;
                    arrDetails.new_scenes.forEach((it) => {
                        it.arrImg = [];
                        it.house_img.forEach((img) => {
                            it.arrImg.push(img.img_url);
                        });
                    });
                    let arrScenes = [];
                    arrDetails.scenes.forEach((item) => {
                        arrScenes.push({
                            scenes_id: item.scenes_id,
                            goods_id: item.goods_id,
                            scene_img: item.house_type_img,
                            goods_type_id: item.devices_id,
                            scene_video: item.mp4_info.mp4_id,
                        });
                    });
                    let arrPlot = {
                        name: arrDetails.plot.name,
                        city: arrDetails.plot.city,
                        district: arrDetails.plot.district,
                        province: arrDetails.plot.province,
                        distance: arrDetails.plot.distance,
                        telephone: arrDetails.plot.telephone,
                        address: arrDetails.plot.address,
                        lng: arrDetails.plot.longitude,
                        lat: arrDetails.plot.latitude,
                    };
                    let arrPloteaid = {
                        name: arrDetails.plot.name,
                        city: arrDetails.plot.city,
                        district: arrDetails.plot.district,
                        province: arrDetails.plot.province,
                        distance: arrDetails.plot.distance,
                        telephone: arrDetails.plot.telephone,
                        address: arrDetails.plot.address,
                        longitude: arrDetails.plot.longitude,
                        latitude: arrDetails.plot.latitude,
                    };
                    //  console.log("scenes数据结构", JSON.stringify(arrScenes));
                    this.arrScenes = arrScenes;
                    this.arrPlot = arrPlot;
                    this.arrPloteaid = arrPloteaid;
                }
                //  console.log("案例详情", res);
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import 'index.scss';
</style>
